import { render } from "./PlayButtonComponent.vue?vue&type=template&id=34890694"
import script from "./PlayButtonComponent.vue?vue&type=script&lang=ts"
export * from "./PlayButtonComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script